import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="blob" id="blob"></a>
    <h1 {...{
      "id": "windowblob"
    }}>{`window.Blob`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: UXP v6.3  `}</p>
    <a name="blob-size" id="blob-size"></a>
    <h2 {...{
      "id": "size"
    }}>{`size`}</h2>
    <p>{`Size of the Blob in bytes`}</p>
    <a name="blob-type" id="blob-type"></a>
    <h2 {...{
      "id": "type"
    }}>{`type`}</h2>
    <p>{`MIME type of the Blob`}</p>
    <a name="blob-arraybuffer" id="blob-arraybuffer"></a>
    <h2 {...{
      "id": "arraybuffer"
    }}>{`arrayBuffer()`}</h2>
    <p>{`Return the contents of the Blob in the form of an ArrayBuffer`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<ArrayBuffer>`}</inlineCode>{` - A promise that resolves with an ArrayBuffer that contains the Blob's data in binary form  `}</p>
    <a name="blob-slice" id="blob-slice"></a>
    <h2 {...{
      "id": "slicestart-end-contenttype"
    }}>{`slice(start, end, contentType)`}</h2>
    <p>{`Return a new Blob containing the specified subset of the Blob's data`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Blob`}</inlineCode>{` - a new Blob object containing the specified subset of the data contained within the Blob on which this method was called  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`start`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`index into the Blob indicating the first byte to include in the new Blob`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`end`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`index into the Blob indicating the first byte that will NOT be included in the new Blob`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`contentType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`content type to assign to the new Blob`}</td>
        </tr>
      </tbody>
    </table>
    <a name="blob-stream" id="blob-stream"></a>
    <h2 {...{
      "id": "stream"
    }}>{`stream()`}</h2>
    <p>{`Returns a ReadableStream which upon reading returns the data contained within the Blob`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStream`}</inlineCode>{` - ReadableStream which, upon reading, returns the contents of the Blob  `}</p>
    <a name="blob-text" id="blob-text"></a>
    <h2 {...{
      "id": "text"
    }}>{`text()`}</h2>
    <p>{`Returns a Promise that resolves with a string containing the contents of the Blob`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<String>`}</inlineCode>{` - A promise that resolves with a string which contains the Blob's data as a text string. The data is always presumed to be in UTF-8 format.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      